<template>
  <v-container class="inner-main pt-2 mb-10">
    <v-row justify="start">
      <v-col class="pb-0">
        <div class="d-flex align-items-center v-step-1">
          <h1 class="text-secondary mr-3">{{ shop?.name }}</h1>
          <v-btn base-color="primary" variant="flat" size="x-small" icon="mdi-pencil" class="text-white mb-2"
            @click="editShopInfos"></v-btn>
        </div>
        <h6>{{ shop?.tagline }}</h6>
      </v-col>
      <v-col align-self="end" class="pb-0">
        <template v-if="shop?.publicityState != 'created' && shop?.publicityState != 'pending'">
          <v-container class="pa-3 justiy-content-between bg-primary deactivated-hint"
            v-if="['deactivated'].includes($getPublicityState())">
            <span class="share-hint" v-html="$t('shop.profile.status.deactivated-hint')"></span>
          </v-container>
          <v-container class="pa-0 justiy-content-between text-right" v-else>
            <span class="share-hint">{{ $t('shop.profile.page.invite') }}</span>
            <CustomSocialsShare :share="shop?.shareUrl"></CustomSocialsShare>
          </v-container>
        </template>
        <template v-else>
          <v-container class="d-flex align-items-center justify-content-end pb-0">

            <EditShopTour ref="EditShopTourManager" v-if="shop.publicityState === 'pending' || shop.publicityState === 'created'"></EditShopTour>

            <v-btn class="px-3 py-1 mr-3" variant="outlined" rounded="xl" size="large" color="primary"
              @click="tourDialog = true">{{ $t('shop.wizard.button.start-wizard') }}</v-btn>
            <v-btn class="px-3 py-1 v-step-7" variant="flat" rounded="xl" size="large" color="primary" :disabled="shop.publicityState === 'pending'"
              @click="validateShop">{{
                shop.publicityState === 'pending' ? $t('shop.wizard.button.profile-pending') :
                  $t('shop.wizard.button.submit-profile') }}</v-btn>
          </v-container>
        </template>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3" sm="3">
        <v-row justify="center" class="pa-0 ma-0 v-step-2">
          <v-responsive :aspect-ratio="1 / 1" :max-width="['xs', 'sm'].includes($globalState.screenWidth) ? 250 : null">
            <v-sheet :style="shopAvatar" color="primary w-100 h-100 clickable" @click="editShopAvatar">
              <v-btn base-color="primary" variant="flat" size="x-small" icon="mdi-pencil" class="text-white edit-btn"
                @click="editShopAvatar"></v-btn>
            </v-sheet>
          </v-responsive>
        </v-row>

        <v-card color="default" class="mt-3 contact-card v-step-4" elevation="0">
          <v-btn base-color="primary" variant="flat" size="x-small" icon="mdi-pencil" class="text-white edit-btn"
            @click="editShopHours"></v-btn>
          <v-card-title>
            <h4>
              {{ $t('shop.wizard.steps.openingTimes.title') }}
            </h4>
          </v-card-title>

          <v-card-text
            v-if="shop != null && [typeof shop?.businessHours] != 'undefined' && shop?.businessHours.length >= 1">

            <div v-for="entry in shop?.businessHours" :key="entry.id">
              <span class="mr-3 dayDesc">
                {{ $getShortDay(entry.fromDay) }} bis
                {{ $getShortDay(entry.toDay) }}
              </span>
              <!-- <span> -->
                <template v-if="entry.from.hour">
                  {{ entry.from.hour }}:{{ entry.from.minute == 0 ? '00' : entry.from.minute }} - {{ entry.to.hour }}:{{
                    entry.to.minute == 0 ? '00' : entry.to.minute }}
                </template>
                <template v-else>
                  {{ entry.from?.slice(0, 5) }} - {{ entry.to?.slice(0, 5) }}
                </template>
              <!-- </span><br> -->
            </div>
          </v-card-text>
          <v-card-text v-else>
            [Auf Anfrage]
          </v-card-text>
        </v-card>

        <v-card color="default" class="mt-3" elevation="0">
          <v-btn base-color="primary" variant="flat" size="x-small" icon="mdi-pencil" class="text-white edit-btn"
            @click="editShopInfos"></v-btn>
          <v-card-title>
            <h4>
              {{ $t('main.footer.contact') }}
            </h4>
          </v-card-title>

          <v-card-text class="text-center">
            <div class="text-left">
              <span v-if="shop?.street != '' && [typeof shop?.street] != 'undefined'">
                {{ shop?.street }}
                <br>
              </span>
              <span v-if="shop?.postcode != '' && shop?.city != ''">
                {{ shop?.postcode }} {{ shop?.city }}<br>
              </span>
              <span v-if="shop?.district != '' && [typeof shop?.district] != 'undefined'">
                {{ shop?.district }}<br>
              </span>
              <br>
            </div>

            <div class="text-left mb-2">
              <v-icon size="x-small" class="me-2" v-if="[typeof shop?.email] != 'undefined'">mdi-mail</v-icon>
              <a class="mr-1" style="font-size:14px" target="_blank" :href="shop?.email"
                v-if="typeof shop?.email != 'undefined'">{{ $t('shop.profile.contact.email') }}</a><br>

              <v-icon size="x-small" class="me-2"
                v-if="typeof shop?.phoneNumber != 'undefined' && shop?.phoneNumber != ''">mdi-phone</v-icon>
              <a style="font-size:14px" :href="shop?.phoneNumber"
                v-if="typeof shop?.phoneNumber != 'undefined' && shop?.phoneNumber != ''">
                {{ shop?.phoneNumber }}
              </a>
              <br v-if="[typeof shop?.phoneNumber] != 'undefined' && shop?.phoneNumber != ''">

              <v-icon size="x-small" class="me-2"
                v-if="typeof shop?.homepage != 'undefined' && shop?.homepage != ''">mdi-earth</v-icon>
              <a style="font-size:14px" target="_blank" :href="shop?.homepage"
                v-if="typeof shop?.homepage != 'undefined' && shop?.homepage != ''">{{
                  $t('shop.profile.contact.website')
                }}</a>
            </div>

            <div class="text-left">
              <v-icon size="x-small" class="me-2"
                v-if="[typeof shop?.facebookUrl] != 'undefined' && shop?.facebookUrl != ''">mdi-facebook</v-icon>
              <a class="mr-1" style="font-size:14px" target="_blank" :href="shop?.facebookUrl"
                v-if="typeof shop?.facebookUrl != 'undefined' && shop?.facebookUrl != ''">{{
                  $t('shop.profile.contact.facebook') }}</a><br
                v-if="typeof shop?.facebookUrl != 'undefined' && shop?.facebookUrl != ''">

              <v-icon size="x-small" class="me-2"
                v-if="typeof shop?.instagramUrl != 'undefined' && shop?.instagramUrl != ''">mdi-instagram</v-icon>
              <a style="font-size:14px" target="_blank" :href="shop?.instagramUrl"
                v-if="typeof shop?.instagramUrl != 'undefined' && shop?.instagramUrl != ''">{{
                  $t('shop.profile.contact.instagram') }}</a>
            </div>

            <v-btn variant="flat" prepend-icon="mdi-map-marker" color="primary" class="text-white mx-auto mt-3"
              @click="$router.push(`/${selectedArea.urlName}/suche/laden/${shop.urlname}/`)">
              {{ $t('shop.profile.contact.location') }}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="9" sm="9">
        <v-carousel contain :cycle="true" interval="5000" class="v-step-3"
          :show-arrows="shop?.gallerieAssets?.length > 1 ? 'hover' : false"
          :hide-delimiter-background="shop?.gallerieAssets?.length <= 1"
          :hide-delimiters="shop?.gallerieAssets?.length <= 1 || !shop?.gallerieAssets"
          :height="['xs', 'sm'].includes($globalState.screenWidth) ? 250 : 500">
          <v-btn base-color="primary" variant="flat" size="x-small" icon="mdi-pencil" class="text-white edit-btn"
            style="top:25px" @click="openAssetPage"></v-btn>
          <v-carousel-item class="" v-for="(post, index) in shop?.gallerieAssets" :key="index"
            :src="`${$cloudFrontApi}${post}/GALLERY_IPAD_RETINA`" contain>
          </v-carousel-item>
          <v-carousel-item class="" v-if="!shop?.gallerieAssets" :key="index"
            :src="`${$cloudFrontAssets}emptygallery_findeling.png`" contain>
          </v-carousel-item>
        </v-carousel>
        <v-row align="center" justify="between" class="mt-1 mt-md-0 mx-0">
          <v-col>
            <CustomIcon :size="30" :type="'none'" :iconName="`icononlineShop`" :fileType="'png'"></CustomIcon>
            Online-Shop
          </v-col>
          <!-- <v-col align-self="end" class="text-right">
            <v-icon>mdi-account</v-icon><span>{{ shop?.totalFollowers }} Folglinge</span>
          </v-col> -->
        </v-row>
        <v-container class="position-relative">
          <v-btn base-color="primary" variant="flat" size="x-small" icon="mdi-pencil" class="text-white edit-btn"
            @click="editShopInfos"></v-btn>

          <h4>{{ $t('shop.profile.page.description') }}</h4>
          <div class="description-wrapper mb-3">
            <template v-if="typeof shop?.description != 'undefined'">
              <p class="paragraphed-text" v-html="shop?.description" :class="{ 'truncated': !openText }">
              </p>
              <a v-if="typeof shop?.description != 'undefined' && shop?.description.length >= 800" @click="toggleText"
                variant="text" class="text-link">
                {{ openText ? 'Weniger' : 'Mehr' }}
              </a>
            </template>
            <p v-else>(keine Ladenbeschreibung vorhanden)</p>
          </div>
          <CustomProductLabel v-for="label in shop?.labels" :key="label.id" :label="label" />


        </v-container>

        <v-card color="default" class="mt-5 v-step-5" elevation="0">
          <v-btn base-color="primary" variant="flat" size="x-small" icon="mdi-pencil" class="text-white edit-btn"
            @click="editShopCategories"></v-btn>
          <v-card-title>
            <h4>
              {{ $t('shop.profile.page.sectors') }}
            </h4>
          </v-card-title>

          <v-card-text class="">
            <v-row justify-md="start">
              <template v-for="category in shop?.productCategories" :key="category.id">
                <v-col cols="12" md="5">
                  <CustomIcon class="mx-3" :size="35" :type="'category'" :iconName="`${category.identifier}_black`">
                  </CustomIcon>
                  <span class="mr-5">
                    {{ category.translations[selectedLanguage.toUpperCase()].value }}
                  </span>
                </v-col>
              </template>
            </v-row>
          </v-card-text>
        </v-card>

        <v-container class="v-step-6 pa-0">
          <v-card color="default" class="mt-3" elevation="0">
            <v-btn base-color="primary" variant="flat" size="x-small" icon="mdi-pencil" class="text-white edit-btn"
              @click="editShopProductGroups"></v-btn>
            <v-card-title>
              <h4>
                {{ $t('shop.profile.productgroup') }}
              </h4>
            </v-card-title>

            <v-card-text
              v-if="shop != null && [typeof shop?.productGroups] != 'undefined' && shop?.productGroups.length >= 1">
              <v-hover v-for="group in shop?.productGroups" :key="group.id">
                <template v-slot:default="{ isHovering, props }">
                  <v-chip v-bind="props" label color="primary" :variant="isHovering ? 'flat' : 'outlined'"
                    class="mr-1 mb-1 hoverable">{{ group.translations[selectedLanguage.toUpperCase()].value }}</v-chip>
                </template>
              </v-hover>
            </v-card-text>
            <v-card-text v-else>
              {{ $t('shop.profile.productgroup-empty') }}
            </v-card-text>
          </v-card>

          <v-card color="default" class="mt-3" elevation="0">
            <v-btn base-color="primary" variant="flat" size="x-small" icon="mdi-pencil" class="text-white edit-btn"
              @click="editShopBrands"></v-btn>
            <v-card-title>
              <h4>
                {{ $t('shop.profile.brands') }}
              </h4>
            </v-card-title>

            <v-card-text v-if="shop != null && [typeof shop?.brands] != 'undefined' && shop?.brands.length >= 1">
              <v-hover v-for="group in shop?.brands" :key="group.id">
                <template v-slot:default="{ isHovering, props }">
                  <v-chip v-bind="props" label color="primary" :variant="isHovering ? 'flat' : 'outlined'"
                    class="mr-1 mb-1 hoverable">{{ group.name }}</v-chip>
                </template>
              </v-hover>
            </v-card-text>
            <v-card-text v-else>
              {{ $t('shop.profile.brands-empty') }}
            </v-card-text>
          </v-card>
        </v-container>
        <v-row justify="space-between" align="center" class="my-3">
          <v-col class="align-items-center" align-self="center">
            <h4>{{ $t('shop.profile.page.news-from', { shopName: shop?.name }) }}</h4>

          </v-col>
          <v-col class="text-right" align-self="center">
            <v-btn rounded="xl" prepend-icon="mdi-plus" size="large" variant="flat" base-color="primary"
              @click="triggerCreateShopNewsPopup()"> {{ $t('global.menu.dealer.newspost') }}</v-btn>
          </v-col>
        </v-row>
        <v-card color="default" class="mt-3" elevation="0" v-if="oldShopNews.length < 1 && !showOldShopNews">

          <v-card-text class="py-16 px-0 text-center">
            <p class="text-center f-16" v-html="$t('shop.profile.stream.hiddenStream.shopText')"></p>
            <v-btn @click="showOldShopNews = true" variant="text" color="primary" class="">{{
              $t('shop.profile.stream.hiddenStream.button') }}</v-btn>
          </v-card-text>
        </v-card>
        <MasonryGrid :items="shopNews" v-else-if="shopNews.length > 1" :max-columns="3" :min-columns="1"
          :column-width="200">
          <template #default="{ item }">
            <CustomNewsCard :editable="true" :img="item.image" :item="item" :title="item.headline"
              :openPostPopup="() => triggerPostPopup(item)" :goToPost="() => $router.push()"
              @delete-news="openConfirmationDialog">
            </CustomNewsCard>
          </template>
        </MasonryGrid>
        <v-row justify="center" class="mt-3"
          v-if="oldShopNews.length > 0 && !showOldShopNews || shopNews.length > 0 && showOldShopNews">
          <template v-if="loading">
            <v-progress-circular color="primary" indeterminate></v-progress-circular>{{ $t('global.common.loading.more')
            }}
          </template>
          <template v-else>
            <div>
              {{ $t('global.common.loading.endOfStream') }}!
            </div>
          </template>
        </v-row>
        <div style="
        position: absolute;
        bottom: 260px;
        left: 50%;
        height: 40px;
        width: 40px;
      " v-intersect="infiniteScrolling"
          v-if="oldShopNews.length > 0 && !showOldShopNews || shopNews.length > 0 && showOldShopNews"></div>
      </v-col>
    </v-row>

    <v-dialog transition="dialog-top-transition" width="auto" v-model="tourDialog" max-width="500">
      <template v-slot:default>
        <v-card>
          <v-card-title>
            {{ $t('shop.wizard.steps.start.title') }}
          </v-card-title>
          <v-card-text class="">
            {{ $t('shop.wizard.steps.start.content') }}
          </v-card-text>

          <v-card-actions class="justify-end">
            <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="default" color="primary" text="Weiter"
              @click="handleTutorialStart"></v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>


    <v-dialog transition="dialog-top-transition" width="auto" v-model="ValidationDialog" max-width="500">
      <template v-slot:default>
        <v-card>
          <v-card-title>
            {{ $t('shop.wizard.steps.validation.title') }}
          </v-card-title>
          <v-card-text class="">
            <span v-html="$t('shop.wizard.steps.validation.content-short')">

            </span>
            <!-- {{ $t('shop.wizard.steps.validation.content') }} -->
            <ul>
              <li v-show="text" v-for="(text, index) in validationText" :key="index">{{ text }}</li>
            </ul>
          </v-card-text>

          <v-card-actions class="justify-end">
            <v-btn class="px-3 py-1" variant="flat" rounded="xl" size="default" color="primary" text="Ok"
              @click="ValidationDialog = false"></v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <EditShopLogoDialog v-model="showLogoDialog"></EditShopLogoDialog>
    <EditShopHoursDialog v-model="showHourDialog"></EditShopHoursDialog>
    <EditShopInfoDialog v-model="showInfoDialog"></EditShopInfoDialog>
    <EditShopCategoryDialog v-model="showCategoryDialog" @submitProfile="saveCategory"></EditShopCategoryDialog>
    <EditShopBrandsDialog v-model="showBrandDialog"></EditShopBrandsDialog>
    <EditShopProductGroupDialog v-model="showProductGroupDialog"></EditShopProductGroupDialog>

    <ConfirmDeletionDialog @confirm-delete="deletePost" v-model="showDeleteConfirmation"></ConfirmDeletionDialog>
  </v-container>
</template>

<script>
import { ref, inject, provide, getCurrentInstance, computed, watch } from 'vue';
import CustomTopSheetDialog from '../custom/CustomTopSheetDialog.vue';
import CustomerSliderImage from '../custom/CustomSliderImage.vue';
import CustomPostCard from '../custom/CustomPostCard.vue';
import CustomSlider from '../custom/CustomSlider.vue';
import EditShopLogoDialog from './modals/EditShopLogoDialog.vue';
import EditShopHoursDialog from './modals/EditShopHoursDialog.vue';
import EditShopInfoDialog from './modals/EditShopInfoDialog.vue';
import { useRoute } from 'vue-router';
import EditShopCategoryDialog from './modals/EditShopCategoryDialog.vue';
import EditShopBrandsDialog from './modals/EditShopBrandsDialog.vue';
import EditShopProductGroupDialog from './modals/EditShopProductGroupDialog.vue';
import ConfirmDeletionDialog from './modals/ConfirmDeletionDialog.vue';
import MasonryGrid from '../custom/MasonryGrid.vue';
import CustomNewsCard from '../custom/CustomNewsCard.vue';
import { STwitter, SPinterest, SFacebook } from 'vue-socials';
import { copyToClipboard } from '@/utils/utils.js';
import CustomSocialsShare from '../custom/CustomSocialsShare.vue';
import EditShopTour from './tours/EditShopTour.vue';

export default {
  components: {
    CustomTopSheetDialog,
    CustomerSliderImage,
    CustomPostCard,
    CustomSlider,
    EditShopLogoDialog,
    EditShopHoursDialog,
    EditShopInfoDialog,
    EditShopCategoryDialog,
    EditShopBrandsDialog,
    EditShopProductGroupDialog,
    MasonryGrid,
    CustomNewsCard,
    ConfirmDeletionDialog,
    STwitter,
    SPinterest,
    SFacebook,
    CustomSocialsShare,
    EditShopTour
  },
  setup() {

    // const showLogoDialog = ref(false);
    const hardToken = localStorage.getItem("hardToken");
    const username = localStorage.getItem("username");
    const softToken = localStorage.getItem("softToken");
    const tourDialog = ref(false);
    const showLogoDialog = ref(false);
    const showHourDialog = ref(false);
    const showInfoDialog = ref(false);
    const showCategoryDialog = ref(false);
    const showBrandDialog = ref(false);
    const showProductGroupDialog = ref(false);
    const ValidationDialog = ref(false);

    const { proxy } = getCurrentInstance();

    const config = {
      itemsToShow: 3
    }
    const shop = inject('shop');
    const openPostPopup = inject('openPostPopup');

    const editShopTourMode = computed(() => shop.value?.publicityState === 'created');

    watch(() => editShopTourMode, (newValue) => {
      console.log("EYE",newValue.value)
      const savedStep = parseInt(localStorage.getItem('editShopTourStep'));
      if (newValue.value && isNaN(savedStep)) {
        tourDialog.value = true;
      }
    }, { immediate: true });

    const copy = (text) => {
      copyToClipboard(text);
    };

    const showDeleteConfirmation = ref(false);
    const idForDeletion = ref(null);
    const openConfirmationDialog = (id) => {
      idForDeletion.value = id;
      showDeleteConfirmation.value = true
    }

    const triggerPostPopup = (item) => {
      if (openPostPopup) {
        openPostPopup(item); // Call the provided function with the `item`
      }
    }
    const fetchOwnShop = inject('fetchOwnShop');
    if (shop == null) {
      fetchOwnShop();
    }

    const createShopNews = inject('createShopNews');
    const triggerCreateShopNewsPopup = (item) => {
      if (openPostPopup) {
        createShopNews(null); // Call the provided function with the `item`
      }
    }
    const totalPages = ref(0);
    const selectedLanguage = localStorage.getItem('selectedLanguage');
    const route = useRoute();
    const selectedArea = inject('selectedArea')
    const openText = ref(false);
    const productCategories = ref(null);
    const shopNews = ref([])
    const showOldShopNews = ref(false);
    const oldShopNews = computed(() => {
      const today = new Date();
      return shopNews.value.filter(news => {
        const publishedDate = new Date(news.publishedAt);
        const differenceInDays = (today - publishedDate) / (1000 * 60 * 60 * 24); // Convert ms to days
        return differenceInDays <= 120; // Check if older than 120 days
      });
    })

    const validationText = ref(null);

    provide('productCategories', productCategories)
    const toggleText = () => {
      openText.value = !openText.value; // Toggle the open state
    }

    const isValid = () => {
      const validation = {
        avatar: null,
        gallery: null,
        branches: null,
      };

      if (!shop.value.gallerieAssets || shop.value.gallerieAssets.length < 1) {
        validation.gallery = proxy.$t('shop.wizard.steps.validation.gallery');
      }
      if (!shop.value.avatar) {
        validation.avatar = proxy.$t('shop.wizard.steps.validation.avatar');
      }
      if (!shop.value.productCategories || shop.value.productCategories.length < 1) {
        validation.branches = proxy.$t('shop.wizard.steps.validation.branches');
      }

      return validation;
    };

    const validateShop = () => {
      const validationResult = isValid();

      if (validationResult.avatar || validationResult.gallery || validationResult.branches) {
        validationText.value = validationResult;
        ValidationDialog.value = true;
      } else {
        // setTimeout(() => {
        //   isPendedShop.value = true;
        //   router.push({
        //     name: 'shop.home.main',
        //     params: { lang: 'EN' } // Replace with dynamic lang if needed
        //   });
        // }, 1000);
        submitShop(); // Call your actual submission logic here
      }
    }

    const submitShop = async () => {
      try {
        const response = await proxy.$axios.put(`/shop/submit`,{} ,{
          headers: {
            'X-Auth-HARDTOKEN': hardToken,
            'X-Auth-SOFTTOKEN': softToken,
            'X-Auth-USER': username
          },
        });

        // Update filteredItems with the API response
      } catch (error) {
        console.error("Error deleting Obj:", error);
      } finally {
        fetchOwnShop();
      }
    }

    const saveCategory = async (array) => {
      console.log(array)
      const obj = { ids: [array[0].id, array[1].id] }
      console.log(obj)
      try {
        const response = await proxy.$axios.put(`/shop/productcategory`, obj, {
          headers: {
            'X-Auth-HARDTOKEN': hardToken,
            'X-Auth-SOFTTOKEN': softToken,
            'X-Auth-USER': username
          },
        });

        // Update filteredItems with the API response
      } catch (error) {
        console.error("Error deleting Obj:", error);
      } finally {
        showCategoryDialog.value = false;
        fetchOwnShop();
      }
    }

    const deletePost = async () => {
      if (!idForDeletion.value) return;
      const id = idForDeletion.value;
      try {
        const response = await proxy.$axios.delete(`/stream/dealer/${id}`, {
          headers: {
            'X-Auth-HARDTOKEN': hardToken,
            'X-Auth-SOFTTOKEN': softToken,
            'X-Auth-USER': username
          },
        });

        // Update filteredItems with the API response
      } catch (error) {
        console.error("Error deleting Obj:", error);
      } finally {
        showDeleteConfirmation.value = false;
        idForDeletion.value = null;
        proxy.fetchShopNews();
      }
    }
    return {
      // showLogoDialog:false,
      config,
      openText,
      toggleText,
      shop,
      selectedLanguage,
      route,
      selectedArea,
      productCategories,
      shopNews,
      triggerPostPopup,
      triggerCreateShopNewsPopup,
      showDeleteConfirmation,
      openConfirmationDialog,
      deletePost,
      showOldShopNews,
      oldShopNews,
      totalPages,
      copy,
      editShopTourMode,
      tourDialog,
      validateShop,
      validationText,
      ValidationDialog,
      saveCategory,
      showLogoDialog,
      showHourDialog,
      showInfoDialog,
      showCategoryDialog,
      showBrandDialog,
      showProductGroupDialog,
    };
  },

  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    shopAvatar() {
      return {
        'background-image': this.shop?.avatar ? `url(${this.$cloudFrontApi}${this.shop?.avatar}/AVATAR)` : 'url(/images/emptyavatar.png)',
        'background-size': 'cover',
      }
    }
  },

  data() {
    return {
      // showLogoDialog: false,
      // showHourDialog: false,
      // showInfoDialog: false,
      // showCategoryDialog: false,
      // showBrandDialog: false,
      // showProductGroupDialog: false,
      items: [
        "Kundenmagnet",
        "Image Booster",
        "Must-Have",
        "Geheimtipp",
        "Margen-Held",
        "PR-Star",
        "Kundenliebling",
        "Durchstarter",
      ],
      images: [
      ]
    }
  },
  mounted() {
    this.fetchProductCategories()
    this.fetchShopNews();
  },

  methods: {
    openAssetPage() {
      console.log(this.$refs.EditShopTourManager.$tours)
      this.$refs.EditShopTourManager.$tours['EditShopTour'].stop();
      this.$router.push('/shop/assets')
    },
    handleTutorialStart() {
      this.tourDialog = false;
      this.$refs.EditShopTourManager.startTour();
    },
    editShopAvatar() {
      this.showLogoDialog = true;
    },
    editShopHours() {
      this.showHourDialog = true;
    },
    editShopInfos() {
      this.showInfoDialog = true;
    },
    editShopCategories() {
      this.showCategoryDialog = true;
    },
    editShopBrands() {
      this.showBrandDialog = true;
    },
    editShopProductGroups() {
      this.showProductGroupDialog = true;
    },
    getShortDay(day, language) {
      const days = {
        EN: {
          MONDAY: "Mo",
          TUESDAY: "Tu",
          WEDNESDAY: "We",
          THURSDAY: "Th",
          FRIDAY: "Fr",
          SATURDAY: "Sa",
          SUNDAY: "Su",
        },
        DE: {
          MONDAY: "Mo",
          TUESDAY: "Di",
          WEDNESDAY: "Mi",
          THURSDAY: "Do",
          FRIDAY: "Fr",
          SATURDAY: "Sa",
          SUNDAY: "So",
        },
      };
      // Convert the input day to uppercase to match the keys in the dictionary
      const uppercaseDay = day.toUpperCase();

      // Check if the language exists in the dictionary
      if (!days[language]) {
        throw new Error(`Unsupported language code: ${language}`);
      }

      // Check if the day exists in the selected language's dictionary
      const translatedDay = days[language][uppercaseDay];
      if (!translatedDay) {
        throw new Error(`Unsupported day: ${day} for language ${language}`);
      }

      return translatedDay;
    },
    infiniteScrolling(entries, observer, isIntersecting) {
      if (isIntersecting && this.loading == false) {

        this.loading = true;
        setTimeout(() => {
          var _this = this;
          if (this.page < this.totalPages) {
            this.page++;
            const hardToken = localStorage.getItem("hardToken");
            const username = localStorage.getItem("username");
            const softToken = localStorage.getItem("softToken");
            this.$axios.get("/v2/stream/dealer/page", {
              params: {
                page: this.page,
                resultsPerPage: 8,
                sortColumn: 'publishedAt',
                sortDirection: 'DESC'
              },
              headers: {
                'X-Auth-HARDTOKEN': hardToken,
                'X-Auth-SOFTTOKEN': softToken,
                'X-Auth-USER': username
              }
            })
              .then((response) => {
                if (response.data.data.length > 1) {
                  _this.shopNews = [..._this.shopNews, ...response.data.data]
                  // response.data.data.forEach((item) =>
                  // );
                }
                // console.log('_this.loading',_this.loading)
                _this.loading = false;
              }
              )
              .catch()

          }
          _this.loading = false;
        }, 500);
      }
    },
    fetchShopNews() {
      // v2/stream/dealer/page?page=0&resultsPerPage=8&sortColumn=publishedAt&sortDirection=DESC
      const hardToken = localStorage.getItem("hardToken");
      const username = localStorage.getItem("username");
      const softToken = localStorage.getItem("softToken");
      var _this = this;
      this.$axios.get("/v2/stream/dealer/page", {
        params: {
          page: this.page,
          resultsPerPage: 8,
          sortColumn: 'publishedAt',
          sortDirection: 'DESC'
        },
        headers: {
          'X-Auth-HARDTOKEN': hardToken,
          'X-Auth-SOFTTOKEN': softToken,
          'X-Auth-USER': username
        }
      })
        .then(this.shopNewsFetched)
        .catch(error => {

          // You can handle specific error codes here, for example, a 401 Unauthorized
          if (error.response && error.response.status === 401 || error.response.status === 403) {
            // Handle token expiration or unauthorized error
            console.log("Session expired or unauthorized. Please log in again.");
            _this.$router.replace('/login');
            // Optionally log the user out or redirect to login page
          }
        });
    },
    shopNewsFetched(response) {
      if (response.data.status == "OK") {
        this.shopNews = response.data.data
        this.totalPages = response.data.totalPages;
      }
    },
    fetchProductCategories() {
      // const softToken = localStorage.getItem("softToken");
      const hardToken = localStorage.getItem("hardToken");
      const username = localStorage.getItem("username");
      var _this = this;
      this.$axios.get("public/data/productcategories")
        .then(this.productCategoriesFetched)
        .catch(error => {

          // You can handle specific error codes here, for example, a 401 Unauthorized
          if (error.response && error.response.status === 401 || error.response.status === 403) {
            // Handle token expiration or unauthorized error
            console.log("Session expired or unauthorized. Please log in again.");
            _this.$router.replace('/login');
            // Optionally log the user out or redirect to login page
          }
        });
    },
    productCategoriesFetched(response) {
      if (response.data.status == "OK") {
        this.productCategories = response.data.data
      }
    },
  },
};
</script>

<style scoped>
.inner-main {
  margin-left: auto;
  margin-right: auto;
  max-width: 1170px;
}


.v-btn-group--density-default.v-btn-group {
  height: unset !important;
}

.description-wrapper {
  position: relative;
}

.description-text {
  display: block;
  max-height: 200px;
  /* Adjust the height based on your design */
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  transition: max-height 0.3s ease-in-out;
  font-size: 14px;
}

.truncated {
  max-height: 200px;
  overflow: hidden;
  /* Limit text height when truncated */
}

.description-text:not(.truncated) {
  max-height: none;
  /* Allow full text to show when toggled */
}

.text-link {
  text-decoration: none;
  color: #1e88e5;
  cursor: pointer;
  float: right;
}

.text-link:hover {
  text-decoration: underline;
}
</style>

<style>
/*.dialog-list-item {
  min-height: 30px !important;
  background-color: transparent !important;
}

*/
.deactivated-hint a {
  color: white !important;
  text-decoration: none;
}

.contact-card .dayDesc {
  min-width: 40%;
  display: block;
  float: left;
}

.dialog-title {
  color: #34a4bf !important;
  font-weight: 300 !important;
}

a:not(.v-btn):not(.trans-btn) {
  text-decoration: none;
  color: #34a4bf !important;
}

a:hover {
  color: #52b8d3;
}

.v-list-item:hover {
  color: black;
}

.share-hint,
.descrption-text {
  font-size: 14px !important;
}

h1 {
  font-size: 36px !important;
  ;
}

h4 {
  font-size: 16px !important;
  font-weight: 700;
}

.f-16 {
  font-size: 16px !important;
}

.edit-btn {
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 1;
}

.v-btn {
  font-size: 14px !important;
  font-weight: 400;
}
</style>
